import { capitalizeEachWords } from 'utils/text'

export const listOfJenjang = [
  'Bawah Pertama',
  'Ahli Pertama',
  'Ahli Muda',
  'Ahli Madya',
  'Ahli Utama',
]

export function isValidJenjang(jenjang: string): boolean {
  return listOfJenjang
    .map((jenjang) => jenjang.toUpperCase())
    .includes(jenjang.toUpperCase())
}

export function mapJenjangName(jenjang: string) {
  if (jenjang === 'Bawah Pertama') return 'Di bawah Penata Muda, III/a'

  return capitalizeEachWords(jenjang)
}
